/**
 * Design System v3 — tokens de Radius (border-radius). Traslado del frame
 * "Radius" de Figma (node 4-573).
 *
 * Fuente de verdad: las CSS vars `--radius-*` del proyecto (ver `index.css`), que
 * ya están mapeadas a Tailwind (`rounded-none/sm/md/lg/full`). Los tokens acá
 * referencian esas vars — no duplican valores — así el DS y la app comparten la
 * misma escala sin drift.
 *
 * Nota: `radius-full` vale `9999px` en el proyecto (Figma lo documenta como
 * `1000px`); ambos producen el mismo pill/círculo completo.
 */

export interface RadiusToken {
  /** Nombre del token, p.ej. 'radius-md'. */
  name: string;
  /** Cuándo usarlo. */
  purpose: string;
  /** Valor en píxeles (documentación). */
  pixels: string;
  /** Valor CSS reutilizable — referencia la var del proyecto. */
  radius: string;
}

export const RADIUS_TOKENS: RadiusToken[] = [
  {
    name: 'radius-none',
    purpose: 'Componentes y superficies con esquinas rectas, sin redondeo.',
    pixels: '0px',
    radius: 'var(--radius-none)',
  },
  {
    name: 'radius-sm',
    purpose:
      'Elementos internos: icon containers, badges, chips, indicadores de tabs, elementos hijos dentro de rounded-md.',
    pixels: '8px',
    radius: 'var(--radius-sm)',
  },
  {
    name: 'radius-md',
    purpose:
      'Componentes interactivos: botones, inputs, filas de lista, option cards, tab containers, dropdowns.',
    pixels: '12px',
    radius: 'var(--radius-md)',
  },
  {
    name: 'radius-lg',
    purpose:
      'Contenedores principales: cards de página, modals, sheets/panels, secciones de contenido.',
    pixels: '16px',
    radius: 'var(--radius-lg)',
  },
  {
    name: 'radius-full',
    purpose: 'Solo avatares circulares y pill badges. No usar en botones ni containers.',
    pixels: '9999px',
    radius: 'var(--radius-full)',
  },
];
